
import { defineComponent, ref, watchEffect, onMounted } from "vue";
import { useStore } from "vuex";
import Documents from "@/views/pages/application/document/Document.vue";
import DocumentsRO from "@/views/pages/application/view/tabs/Document.vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep3 {
  includeBlood: string;
  frequencyMeasure: string;
  volumenMeasure: string;
  measureDetail: string;
}

export default defineComponent({
  name: "step-4",
  components: {
    Documents,
    DocumentsRO,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];
    const step3 = ref<IStep3>({
      includeBlood: "",
      frequencyMeasure: "",
      volumenMeasure: "",
      measureDetail: "",
    });
    onMounted(() => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      
    });

    return {
      step3,
      Documents,
      listDropDownSections,
    };
  },
});
